var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-h6 left-title"},[_c('h3',[_c('b',{staticClass:"font-weight-bold main-post-title text-uppercase",attrs:{"dir":_vm.$store.getters.getTextDirection}},[_vm._v(_vm._s(_vm.title)+" "),_c('hr',{staticClass:"cat-post-title"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }